import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent({color = '#000', props}: any) {
  return (
    <Svg
      width={70}
      height={70}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M45.96 62.222v-5.185c0-2.75-1.006-5.389-2.796-7.333-1.79-1.945-4.218-3.038-6.75-3.038h-19.09c-2.532 0-4.96 1.093-6.75 3.038-1.79 1.944-2.796 4.582-2.796 7.333v5.185"
        fill={color}
      />
      <Path
        d="M45.96 62.222v-5.185c0-2.75-1.006-5.389-2.796-7.333-1.79-1.945-4.218-3.038-6.75-3.038h-19.09c-2.532 0-4.96 1.093-6.75 3.038-1.79 1.944-2.796 4.582-2.796 7.333v5.185"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M26.869 36.296c5.272 0 9.545-4.643 9.545-10.37 0-5.727-4.273-10.37-9.545-10.37s-9.546 4.643-9.546 10.37c0 5.727 4.274 10.37 9.546 10.37zM60.278 62.222v-5.185c-.001-2.297-.705-4.53-2.001-6.346-1.296-1.816-3.11-3.113-5.158-3.687M43.574 15.893c2.053.571 3.873 1.869 5.172 3.688 1.3 1.819 2.005 4.056 2.005 6.358 0 2.303-.705 4.54-2.005 6.359-1.3 1.819-3.12 3.116-5.172 3.687"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default SvgComponent
